var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{staticClass:"mt-8",attrs:{"title":"Who Pays for the Survey?","no_border":true}},[_c('buyer-seller-split',{attrs:{"field":"survey_who_pays","value":_vm.commercial.survey_who_pays,"read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }